// OCTAGON INFINITY RISK DISCLOSURE CONTENT
// Edit this file to update the risk disclosure content

export const riskDisclosureContent = {
  title: "Risk Disclosure",
  subtitle: "Octagon Infinity Investment Platform",
  effectiveDate: "Effective Date: November 14, 2025",
  lastUpdated: "Last Updated: November 14, 2025",
  
  sections: [
    {
      id: "important-notice",
      title: "Important Notice",
      content: `THIS RISK DISCLOSURE STATEMENT IS A CRITICAL DOCUMENT THAT YOU MUST READ AND UNDERSTAND BEFORE PARTICIPATING IN OCTAGON INFINITY'S VIP PASS NFT PROGRAM AND REAL ESTATE INVESTMENT PLATFORM.

Investment in VIP Pass NFTs and participation in our real estate investment platform involves substantial risk and may not be suitable for all investors. You should carefully consider whether such investment is appropriate for you in light of your financial circumstances, investment objectives, and risk tolerance.

BY PURCHASING A VIP PASS NFT OR USING OUR SERVICES, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND ACCEPTED ALL RISKS DESCRIBED IN THIS DISCLOSURE.

This document does not disclose all possible risks. You should consult with independent financial, legal, and tax advisors before making any investment decision.`
    },
    
    {
      id: "general-investment-risks",
      title: "1. General Investment Risks",
      content: `1.1 Loss of Capital:
• You may lose some or all of your investment
• There is no guarantee of returns, profits, or capital preservation
• Projected returns of 2%-8% monthly are estimates and not guarantees
• Past performance does not indicate future results
• Market conditions can result in negative returns

1.2 High-Risk Investment:
• Real estate tokenization is a relatively new and untested investment model
• The combination of NFTs and real estate investment carries unique risks
• This investment should be considered speculative and high-risk
• Only invest capital that you can afford to lose entirely

1.3 Illiquidity:
• Despite NFT transferability, there is no guarantee of a liquid secondary market
• You may not be able to sell your VIP Pass NFT when desired
• Market prices on secondary markets may be significantly lower than purchase price
• Redemption or exit options may be limited or unavailable

1.4 No FDIC Insurance or Government Protection:
• Your investment is not protected by government deposit insurance
• There is no investor protection fund or compensation scheme
• We are not a licensed securities broker or investment advisor`
    },
    
    {
      id: "real-estate-risks",
      title: "2. Real Estate Investment Risks",
      content: `2.1 Property Value Fluctuation:
• Real estate values can decrease due to market conditions
• Economic downturns can significantly impact property values
• Local market conditions may differ from national trends
• Property values may not recover from declines

2.2 Rental Income Volatility:
• Rental income may be lower than projected
• Vacancy rates may be higher than anticipated
• Tenants may default on rent payments
• Operating costs may exceed projections

2.3 Property-Specific Risks:
• Individual properties may experience unforeseen problems
• Maintenance and repair costs can be unpredictable
• Environmental issues or hidden defects may arise
• Renovation or development projects may face delays or cost overruns

2.4 Geographic Concentration:
• Focus on European markets exposes investments to regional economic conditions
• Political instability or regulatory changes in specific countries
• Currency fluctuations affecting property values and returns
• Natural disasters or climate-related events in specific regions

2.5 Development Risks:
• New development projects carry construction and completion risks
• Projects may not be completed on time or budget
• Market conditions may change before project completion
• Permits and approvals may be delayed or denied`
    },
    
    {
      id: "nft-blockchain-risks",
      title: "3. NFT and Blockchain Technology Risks",
      content: `3.1 Technology Risks:
• Smart contracts may contain bugs or vulnerabilities
• Blockchain networks may experience congestion or outages
• Transactions are irreversible and cannot be undone
• Loss of private keys results in permanent loss of access to NFTs

3.2 Smart Contract Risks:
• Smart contracts execute automatically and cannot be modified after deployment
• Errors in smart contract code can lead to loss of funds
• Upgrades or changes to smart contracts may affect NFT functionality
• We cannot reverse or cancel blockchain transactions

3.3 Network Risks:
• Ethereum or other blockchain networks may experience technical issues
• Network congestion can lead to high transaction fees (gas fees)
• Hard forks or protocol changes may affect NFT functionality
• Network attacks or exploits may compromise security

3.4 Wallet and Security Risks:
• You are solely responsible for securing your cryptocurrency wallet
• Loss or theft of private keys results in irreversible loss of NFTs
• Phishing attacks and scams targeting cryptocurrency users
• Malware or hacking attempts may compromise wallet security

3.5 NFT Market Risks:
• NFT markets are highly volatile and speculative
• Demand for NFTs can fluctuate dramatically
• Liquidity in NFT markets can be extremely limited
• NFT values may become worthless`
    },
    
    {
      id: "regulatory-risks",
      title: "4. Regulatory and Legal Risks",
      content: `4.1 Uncertain Regulatory Environment:
• Cryptocurrency and NFT regulations are evolving and uncertain
• New laws or regulations may restrict or prohibit our operations
• Regulatory changes may affect the value or transferability of NFTs
• We may be required to suspend or terminate services due to regulatory developments

4.2 Securities Law Compliance:
• VIP Pass NFTs may be classified as securities in some jurisdictions
• Securities regulations vary significantly across countries
• We may face regulatory enforcement actions
• NFT holders may face restrictions on resale or transfer

4.3 Tax Implications:
• Tax treatment of NFTs and cryptocurrency investments is complex and uncertain
• You are responsible for determining and paying all applicable taxes
• Tax laws may change, affecting the profitability of investments
• Different jurisdictions may tax NFTs and crypto gains differently

4.4 KYC/AML Compliance:
• We are required to conduct identity verification and due diligence
• Failure to complete KYC/AML procedures will result in inability to participate
• Your information may be shared with regulatory authorities
• Enhanced due diligence may be required for certain investors

4.5 Legal Jurisdiction:
• Disputes may involve complex questions of jurisdiction and applicable law
• Enforcement of rights may be difficult or impossible in some jurisdictions
• Legal costs of pursuing claims may be prohibitive`
    },
    
    {
      id: "platform-operational-risks",
      title: "5. Platform and Operational Risks",
      content: `5.1 Platform Dependency:
• Your investment depends on the continued operation of our platform
• We may suspend, modify, or discontinue services at any time
• Technical issues or cyberattacks may interrupt access to the platform
• Platform failures could affect profit distributions or NFT functionality

5.2 Management and Performance:
• Investment success depends on our management team's decisions and expertise
• Management may make poor investment decisions
• Key personnel may leave or be unavailable
• We have discretion over project selection and fund allocation

5.3 Operational Risks:
• Internal processes and systems may fail or be inadequate
• Human error may result in losses or operational issues
• Third-party service providers may fail to perform
• Insurance coverage may be insufficient or unavailable

5.4 Cybersecurity Risks:
• Platform may be vulnerable to cyberattacks or data breaches
• User accounts may be compromised despite security measures
• Sensitive information may be exposed in a security incident
• Distributed denial-of-service (DDoS) attacks may disrupt service

5.5 Third-Party Risks:
• We rely on various third-party service providers
• Failure of payment processors, wallet providers, or other services
• Third parties may change terms, pricing, or discontinue services
• Limited recourse against third-party service failures`
    },
    
    {
      id: "market-economic-risks",
      title: "6. Market and Economic Risks",
      content: `6.1 Economic Downturn:
• Economic recessions can severely impact real estate values and rental income
• Financial crises may affect access to credit and property financing
• Interest rate increases can negatively affect real estate markets
• Unemployment and economic hardship reduce demand for properties

6.2 Market Volatility:
• Real estate and cryptocurrency markets are inherently volatile
• Sudden market movements can result in significant losses
• Investor sentiment can change rapidly
• External events can cause unexpected market reactions

6.3 Currency and Exchange Rate Risks:
• Investments are made in various currencies (ETH, EUR, USD)
• Currency exchange rates fluctuate and can affect returns
• Currency conversion fees and spreads reduce returns
• Capital controls or currency restrictions may be imposed

6.4 Inflation and Interest Rates:
• Inflation erodes the real value of returns
• Rising interest rates can decrease property values
• Borrowing costs may increase, affecting project financing
• Central bank policies may affect market conditions

6.5 Geopolitical Risks:
• Political instability or conflicts may affect markets
• International trade disputes or sanctions
• Changes in government policies or leadership
• Social unrest or civil disturbances in investment regions`
    },
    
    {
      id: "concentration-risks",
      title: "7. Concentration and Diversification Risks",
      content: `7.1 Limited Diversification:
• Focus on European real estate markets limits diversification
• Geographic concentration increases exposure to regional risks
• Limited number of properties or projects may lack diversification
• Sector-specific risks are not mitigated by diversification

7.2 Project Concentration:
• Individual projects may represent a significant portion of total investment
• Poor performance of a single project can materially affect overall returns
• Limited ability to rebalance or adjust portfolio allocation
• Management discretion in project selection may result in concentration

7.3 Asset Class Concentration:
• Exclusive focus on real estate limits diversification benefits
• Real estate market downturns affect entire portfolio
• No exposure to other asset classes for risk mitigation
• Correlation with broader real estate market cycles`
    },
    
    {
      id: "exit-liquidity-risks",
      title: "8. Exit Strategy and Liquidity Risks",
      content: `8.1 No Guaranteed Exit:
• There is no guaranteed mechanism for exiting your investment
• We do not offer redemption or buyback programs
• You may be unable to sell your NFT at any price
• Holding period may be indefinite

8.2 Secondary Market Limitations:
• Secondary NFT markets may have limited participants
• Bid-ask spreads may be wide, resulting in significant transaction costs
• Market manipulation or wash trading may occur
• Low trading volumes may prevent sales at desired prices

8.3 Transfer Restrictions:
• Legal or regulatory restrictions may limit NFT transfers
• Platform policies may impose transfer conditions
• Technical issues may prevent or delay transfers
• Some jurisdictions may prohibit NFT resales

8.4 Lock-up Periods:
• Certain investment components may have lock-up or vesting periods
• Early exit penalties or restrictions may apply
• Profit distributions may be subject to minimum holding requirements`
    },
    
    {
      id: "projection-disclaimer",
      title: "9. Forward-Looking Statements and Projections",
      content: `9.1 No Guarantees:
• All projected returns, growth rates, and performance estimates are hypothetical
• Actual results may differ materially from projections
• Projections are based on assumptions that may not be realized
• We do not guarantee any specific investment outcomes

9.2 Tier Return Rates:
The stated tier returns (2%, 4%, 6%, 8% monthly) are:
• Target rates based on assumptions and projections
• Not guaranteed and may not be achieved
• Subject to market conditions and property performance
• Calculated before fees, expenses, and taxes

9.3 Forward-Looking Statements:
• Statements about future plans, strategies, and expectations are forward-looking
• Actual events and results may differ significantly
• We do not undertake to update forward-looking statements
• Reliance on forward-looking statements is at your own risk

9.4 Historical Performance:
• Historical performance information, if any, does not predict future results
• Past success does not guarantee future success
• Market conditions and circumstances change over time`
    },
    
    {
      id: "other-risks",
      title: "10. Other Material Risks",
      content: `10.1 Conflicts of Interest:
• Management may have conflicts between company interests and investor interests
• Related-party transactions may not be on arm's length terms
• Management may receive compensation that is not performance-based
• Directors and officers may have other business interests

10.2 Limited Information:
• Real estate investment information may be limited or delayed
• Property valuations may be subjective or inaccurate
• Financial reporting may lack detail or frequency
• Independent audits or verifications may not be conducted

10.3 Force Majeure:
• Unforeseen events beyond our control may affect operations
• Natural disasters, pandemics, or extreme weather events
• Acts of terrorism, war, or civil unrest
• No liability for losses due to force majeure events

10.4 Technology Obsolescence:
• Blockchain technology and NFT standards may become obsolete
• New technologies may render our platform outdated
• Competing platforms may offer superior features or returns
• Technology migration may be costly or impossible`
    },
    
    {
      id: "investor-suitability",
      title: "11. Investor Suitability and Recommendations",
      content: `11.1 Suitable Investors:
Investment in VIP Pass NFTs may be suitable only for investors who:
• Can afford to lose their entire investment
• Have substantial financial resources and do not need liquidity
• Have experience with high-risk investments
• Understand cryptocurrency, blockchain, and NFT technology
• Have consulted with independent professional advisors
• Are comfortable with long-term, illiquid investments

11.2 Unsuitable Investors:
This investment is NOT suitable for:
• Inexperienced investors or those unfamiliar with high-risk investments
• Investors requiring guaranteed income or capital preservation
• Investors who cannot afford to lose their investment
• Investors requiring liquidity or the ability to exit quickly
• Investors who do not understand the risks disclosed herein

11.3 Professional Advice:
YOU SHOULD CONSULT WITH QUALIFIED PROFESSIONALS BEFORE INVESTING:
• Financial advisors regarding investment suitability
• Legal counsel regarding legal and regulatory implications
• Tax professionals regarding tax consequences
• Technical experts regarding blockchain and cryptocurrency aspects

11.4 Independent Decision:
• Your investment decision must be your own
• We do not provide investment, legal, or tax advice
• You must conduct your own due diligence
• Do not invest based solely on information we provide`
    },
    
    {
      id: "acknowledgment",
      title: "12. Investor Acknowledgment",
      content: `BY PURCHASING A VIP PASS NFT AND PARTICIPATING IN OCTAGON INFINITY'S PLATFORM, YOU ACKNOWLEDGE AND CONFIRM THAT:

1. You have read and understood this entire Risk Disclosure Statement
2. You understand that investment in VIP Pass NFTs is highly speculative and risky
3. You can afford to lose your entire investment without financial hardship
4. You have consulted with independent professional advisors as appropriate
5. You understand that projected returns are not guaranteed
6. You accept full responsibility for your investment decision
7. You will not hold Octagon Infinity liable for investment losses
8. You understand the risks associated with cryptocurrency and blockchain technology
9. You are aware that regulatory changes may affect your investment
10. You acknowledge that there is no guaranteed exit or liquidity

YOU FURTHER ACKNOWLEDGE THAT:
• This Risk Disclosure does not cover all possible risks
• Additional risks may emerge over time
• You have had the opportunity to ask questions about the investment
• No representations or warranties have been made beyond those in our Terms of Service

FAILURE TO UNDERSTAND THESE RISKS MAY RESULT IN FINANCIAL LOSS. IF YOU DO NOT UNDERSTAND OR ACCEPT THESE RISKS, DO NOT PURCHASE VIP PASS NFTS OR USE OUR SERVICES.`
    },
    
    {
      id: "contact-questions",
      title: "13. Questions and Additional Information",
      content: `If you have questions about this Risk Disclosure or need additional information, please contact us:

Email: info@octagon8.io
Support: support@octagon8.io
Legal Inquiries: legal@octagon8.io

Mailing Address:
Octagon Infinity
[Company Address]
[City, Country, Postal Code]

We strongly encourage you to ask questions and seek clarification before making any investment decision. However, please note that we cannot provide personalized investment advice, and you should consult with independent professional advisors for guidance tailored to your specific circumstances.

This Risk Disclosure Statement is an integral part of our Terms of Service and should be read in conjunction with all other legal documents governing your use of our Services.

Last Updated: November 14, 2025
Version: 1.0`
    }
  ]
};
